import React from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router';
import { WrapRequest } from 'wrap-request';
import { Badge } from '@components/ui/badge';
import { PageHeader } from '../components/page-header';
import { PageTabs } from '../components/page-tabs';
import { Api as CorporateApi, PromoterDto } from '../core/api/CorporateClient';
import { useTabs } from '../components/hooks/use-tabs';
import { TenantDto } from '@api/TenantClient';
import { TenantStatusBadge } from '../tenants';
import { useStore } from './store';

const pageTabs = [
    { label: 'Details', id: 'details' },
    { label: 'Contract', id: 'contract' },
    { label: 'Features', id: 'features' },
    { label: 'Employees', id: 'employees' },
    { label: 'Community', id: 'community' },
    { label: 'Users', id: 'users' }
];

export const TenantCorporateContext = React.createContext<
    CorporateApi<unknown>
>({} as CorporateApi<unknown>);
type TenantFeaturesType = WrapRequest<{
    company: PromoterDto;
    tenant: TenantDto;
}>;

export const TenantFeaturesContext = React.createContext<TenantFeaturesType>(
    {} as TenantFeaturesType
);

export const Tenant = () => {
    const { tenantName } = useParams();
    const { pathname } = useLocation();
    const { tab, getPageLink, setPageTab } = useTabs(pageTabs);
    const navigate = useNavigate();

    const { corporateClient, tenantFeatures } = useStore();

    const changePage = (page: number) => {
        navigate(getPageLink(page));
    };

    React.useEffect(() => {
        setPageTab(pathname, 3);
    }, [pathname]);

    return (
        <TenantCorporateContext.Provider value={corporateClient}>
            <TenantFeaturesContext.Provider value={tenantFeatures}>
                <PageHeader
                    title={tenantName}
                    badges={tenantFeatures.match({
                        fetched: ({ tenant }) => (
                            <>
                                <TenantStatusBadge status={tenant.status} />
                                <Badge variant="muted">{tenant.type}</Badge>
                            </>
                        )
                    })}
                />
                <PageTabs tabs={pageTabs} value={tab} onChange={changePage} />
                <div className="mt-6">
                    <Outlet />
                </div>
            </TenantFeaturesContext.Provider>
        </TenantCorporateContext.Provider>
    );
};

export default Tenant;
